/**
 * @typedef {object} TraverseSelector
 * @property {(string[] | string)=} traverse
 * @property {string=} selector 
 */

/**
 * @param {HTMLElement} el
 * @param {TraverseSelector} selector
 * @returns {HTMLElement|null}
 */
export function findElement(el, selector) {
  if (el == null) return null
  if (selector == null) throw new Error('selector is null')
  let _el = traverse(el, selector.traverse)
  if (_el == null) return null
  if (selector.selector != null) {
    _el = _el.querySelector(selector.selector)
  }
  return _el
}

/**
 * @param {HTMLElement} el
 * @param {string[] | string} traversalSelectors 
 * @returns {HTMLElement|null}
 */
export function traverse(el, traversalSelectors) {
  if (el == null) return null
  if (traversalSelectors == null) return el
  const selectorsArr = Array.isArray(traversalSelectors) ? traversalSelectors : [traversalSelectors]
  let _el = el
  for (let i = 0; i < selectorsArr.length; i++) {
    if (_el.parentElement == null) return null
    _el = _el.parentElement.closest(selectorsArr[i])
    if (_el == null) return null
  }
  return _el
}

/**
 * 
 * @param {any} obj
 * @return {obj is TraverseSelector} 
 */
export function isTraverseSelector(obj) {
  return obj != null && typeof obj === 'object' && (obj.traverse != null || obj.selector != null)
}